export default __webpack_public_path__ + "static/media/team-1.1f6e01ea.jpg";